import { Coffee, MoonStar, ShieldCheck } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { IMG } from "../config";

const RITUALS = [
  { icon: Coffee, text: "Menyeduh kopi dan mendengar keluh kesah warga secara langsung" },
  { icon: ShieldCheck, text: "Menjaga keamanan Cianjay saat sebagian besar orang tertidur" },
  { icon: MoonStar, text: "Dari dusun ke dusun, dari satu pos ronda ke pos ronda lainnya" },
];

export const NightPatrol = () => (
  <section id="ronda" data-testid="nightpatrol-section" className="relative overflow-hidden bg-night py-24 sm:py-32">
    <div className="pointer-events-none absolute top-10 left-1/4 w-72 h-72 rounded-full bg-amber2/10 blur-3xl" />
    <div className="pointer-events-none absolute bottom-0 right-0 w-96 h-96 rounded-full bg-terra/10 blur-3xl" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-6">
        <Reveal>
          <div className="inline-flex items-center gap-2.5 rounded-full border border-nightline bg-nightcard px-4 py-2 mb-7" data-testid="ronda-live-badge">
            <span className="w-2 h-2 rounded-full bg-amber2 animate-glow-dot" />
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-amber2">
              Sedang Berjaga · 24/7
            </span>
          </div>
        </Reveal>
        <SectionHeading
          bab="Bab 04"
          label="Jemput Bola & Jaga Malam"
          title="24/7: Dari Balai Desa ke Dusun-Dusun"
          dark
          testid="ronda"
        />
        <Reveal delay={0.25}>
          <p className="mt-7 text-base leading-relaxed text-[#C4CFC7]">
            Aspirasi paling jujur jarang lahir di ruang rapat formal. Itulah kenapa malam hari adalah waktu
            saya untuk kembali turun ke jalan. Saya duduk, menyeduh kopi bersama warga, dan mendengar keluh
            kesah Anda secara langsung.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#C4CFC7]">
            Karena masalah warga tak pernah kenal jam kerja, saya memastikan diri untuk selalu{" "}
            <span className="text-amber2 font-semibold">hadir, mendengar, dan menjaga</span>.
          </p>
        </Reveal>
        <div className="mt-9 space-y-4">
          {RITUALS.map((r, i) => (
            <Reveal key={i} delay={0.3 + i * 0.1}>
              <div className="flex items-center gap-4 rounded-2xl border border-nightline bg-nightcard/70 px-5 py-4" data-testid={`ronda-ritual-${i}`}>
                <span className="grid place-items-center w-10 h-10 rounded-xl bg-amber2/15 text-amber2 shrink-0">
                  <r.icon size={18} />
                </span>
                <p className="text-sm text-[#DCE5DE] leading-relaxed">{r.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="lg:col-span-6">
        <Reveal delay={0.2} y={50}>
          <div className="relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-tr from-amber2/20 via-transparent to-terra/20 blur-xl" />
            <div className="relative overflow-hidden rounded-[2rem] border border-nightline shadow-2xl">
              <img
                src={IMG.ronda}
                alt="Kopi malam bersama warga di pos ronda bambu"
                data-testid="ronda-photo"
                className="w-full aspect-[4/3] object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-night/95 to-transparent p-6 pt-16">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-amber2">Pos Ronda · Dusun 3</p>
                <p className="mt-1.5 font-serif italic text-lg text-[#F4EFE6]">
                  "Kopi boleh dingin, telinga untuk warga tidak boleh."
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
